import React from "react"
import { fmt } from "../helpers/format"

const Waterfall = ({ steps = [] }) => {
  const max = Math.max(1, ...steps.map(s => Math.abs(s.value?.cents || 0)))
  const w = 640
  const h = 220
  const barW = 80
  const gap  = (w - barW * steps.length) / (steps.length + 1)
  const baseY = h - 30

  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-44">
      <line x1="0" y1={baseY} x2={w} y2={baseY} stroke="#E2E8F0" strokeWidth="1" />
      {steps.map((step, i) => {
        const cents = Math.abs(step.value?.cents || 0)
        const barH  = (cents / max) * (h - 70)
        const x = gap + i * (barW + gap)
        const y = baseY - barH
        return (
          <g key={i}>
            <rect x={x} y={y} width={barW} height={barH} rx="4" fill={i === steps.length - 1 ? "#10B981" : "#3B82F6"} opacity="0.9" />
            <text x={x + barW / 2} y={y - 8} textAnchor="middle" className="fill-slate-700" fontSize="11" fontWeight="600">
              {step.value?.formatted || "—"}
            </text>
            <text x={x + barW / 2} y={baseY + 16} textAnchor="middle" className="fill-slate-500" fontSize="10.5">
              {step.label}
            </text>
          </g>
        )
      })}
    </svg>
  )
}

export default Waterfall
